import {
  Home,
  GroupOutlined,
  RecentActorsOutlined,
  CasesOutlined,
  ViewTimelineOutlined,
  BadgeOutlined,
  AssessmentOutlined,
  Schedule,
  Payments,
  RequestPage,
  WorkOffOutlined,
  FreeCancellation,
  BeachAccess,
  RequestPageOutlined,
  RequestQuoteOutlined,
  Dashboard,
  HouseOutlined,
  PersonAddAlt,
  AdminPanelSettings,
} from '@mui/icons-material';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import { Badge } from '@mui/material';
import ReactIntlWrapper from 'components/i18n/ReactIntlWrapper';
import { JSX, useEffect, useState } from 'react';
import Api from 'axiosApi/api';

// Deprecated
export function renderModuleAvatar(module) {
  // Dictionary to map notification's module property to icons
  const moduleIconMap: Record<string, JSX.Element> = {
    address: <HouseOutlined />,
    home: <Home />,
    client: <GroupOutlined />,
    provider: <RecentActorsOutlined />,
    project: <CasesOutlined />,
    timesheet: <ViewTimelineOutlined />,
    employee: <BadgeOutlined />,
    reports: <AssessmentOutlined />,
    reports_timesheet: <Schedule />,
    reports_billing: <Payments />,
    reports_billing_client: <RequestPage />,
    timeoff: <WorkOffOutlined />,
    timeoffrrhh: <FreeCancellation />,
    holidays: <BeachAccess />,
    invoice: <RequestPageOutlined />,
    myInvoices: <RequestQuoteOutlined />,
    corporateEntity: <Badge/>,
    role: <Badge/>,
    billing: <Payments/>,
    event: <BeachAccess/>,
    contactInfo: <ContactPhoneIcon/>,
    job: <CasesOutlined/>,
    task: <CasesOutlined/>,
    User: <PersonAddAlt/>,
    workflow: <Badge/>,
    admin: <AdminPanelSettings/>,
  
  };

  const icon = moduleIconMap[module];

  return icon || <Dashboard />;
}

export function getNotificationLocale(resourceId: string, params: any[]): string {
  const values = Object.assign(
    {},
    ...params.map((param) => {
      const key = param.PlaceholderKey;
      const value = param.PlaceholderValue;

      // If the value is a translation key, use the translation
      const translatedValue = ReactIntlWrapper.has(value) ? ReactIntlWrapper.get(value) : value;

      return { [key]: translatedValue };
    })
  );

  return ReactIntlWrapper.get(resourceId, values);
}

// Module-level cache: "entityType:X / entityId:Y" → resolved name string
const entityNameCache = new Map<string, string>();

// Pattern produced by the lambda for the uploaded/ path
const ENTITY_REF_PATTERN = /^entityType:(\d+) \/ entityId:(\d+)$/;

/**
 * Resolves params that contain an entity reference ("entityType:X / entityId:Y")
 * in the `submittedBy` placeholder by fetching the employee name via the API.
 * Returns the params array with the resolved name substituted in, or the
 * original params while loading (so the raw string shows until resolved).
 */
export function useResolvedParams(params: any[], api: Api): any[] {
  const [resolvedParams, setResolvedParams] = useState<any[]>(params);

  useEffect(() => {
    let cancelled = false;

    const resolve = async () => {
      const updated = await Promise.all(
        params.map(async (param) => {
          if (param.PlaceholderKey !== 'submittedBy') return param;

          const match = ENTITY_REF_PATTERN.exec(param.PlaceholderValue);
          if (!match) return param;

          const cacheKey = param.PlaceholderValue;
          if (entityNameCache.has(cacheKey)) {
            return { ...param, PlaceholderValue: entityNameCache.get(cacheKey) };
          }

          const entityId = parseInt(match[2]);
          try {
            const response = await api.employeeApi.apiVversionEmployeeIdGet(entityId, '1');
            const employee = response.data?.data?.employee;
            const name = employee
              ? `${employee.name ?? ''} ${employee.lastName ?? ''}`.trim() || cacheKey
              : cacheKey;
            entityNameCache.set(cacheKey, name);
            return { ...param, PlaceholderValue: name };
          } catch {
            return param;
          }
        })
      );

      if (!cancelled) setResolvedParams(updated);
    };

    resolve();
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.map((p) => p.PlaceholderValue).join('|')]);

  return resolvedParams;
}

export const getRowHeight = (params) => {
  try {
    const parsed = JSON.parse(params.model.message);
    const localeText = getNotificationLocale(parsed.message?.ResourceID, parsed.message?.Params || []) ;
    
    const charsPerLine = 80; 
    const lines = Math.ceil(localeText.length / charsPerLine);
    const baseHeight = 50;
    const lineHeight = 20;
    
    return Math.max(70, baseHeight + (lines * lineHeight));
  } catch (error) {
    return 70;
  }
}

// Deperecated
export const getPriorityColor = (priority: string | undefined) => {
  switch (priority?.toLowerCase()) {
    case 'high':
      return 'error.main'; 
    case 'medium':
      return 'warning.main';
    case 'low':
      return 'success.main'; 
    default:
      return 'grey.300'; 
  }
};
